



























import Vue from 'vue';

export default Vue.extend({
  computed: {
    inputType(): string {
      return this.type !== `date` ? this.type : `text`;
    },
  },
  props: {
    checked: Boolean,
    enabled: {
      default: true,
      type: Boolean,
    },
    identifier: {
      default: ``,
      type: String,
    },
    maxLength: {
      default: 999,
      type: Number,
    },
    placeholder: {
      default: ``,
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    type: {
      default: `text`,
      type: String,
    },
    value: {
      default: ``,
      type: [String, Number],
    },
  },
});
